import pianoUrls from './urls';
import device from './tools/device';

export const listenForScrollAnchor = () => {
	const manageMyAccountEl = document.querySelector( '.js-manage-my-account' );

	if ( ! manageMyAccountEl) {
		return;
	}

	const mmaTop = manageMyAccountEl.offsetTop;

	window.addEventListener( 'message', event => {
		if ( pianoUrls.includes( event.origin ) ) {
			const pianoIframe = document.querySelector(
				'.js-manage-my-account iframe',
			);

			if ( ! pianoIframe ) {
				return;
			}

			// Listen for scrollAnchor and send the parameter to Piano
			if ( event.data === 'scrollAnchor' ) {
				const currentUrl = window.location.href;
				const url = new URL( currentUrl );
				const searchParams = url.searchParams;
				const parameterValue = searchParams.get( 'section' );
				if ( pianoIframe.contentWindow ) {
					pianoIframe.contentWindow.postMessage(
						{ anchor: parameterValue },
						'*',
					);
				}
			}

			/**
			 * Get the scroll point based on the device
			 *
			 * @returns {number} The scroll point
			 */
			const getScrollPoint = () => {
				switch ( device() ) {
					case 'MOBILE_PORTRAIT':
					case 'MOBILE_LANDSCAPE':
						return 110;
					case 'TABLET':
						return 130;
					default:
						return 160;
				}
			};

			// Receive the anchor point and scroll to the anchor point
			if ( event.data.anchorPoint ) {
				const setScrollPoint = getScrollPoint();
				window.scrollTo( {
					top: mmaTop + event.data.anchorPoint - setScrollPoint,
					behavior: 'smooth',
				} );
			}
		}
	} );
};
export default listenForScrollAnchor;
